import React from 'react';

const Home = () => {
  return (
    <div className="w3-animate-opacity">
      <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
      <h1 className='title'>WELCOME</h1>
      <p>You have entered the website of Michael Rodriguez.</p>
    </div>
  )
};

export default Home;